import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCoins: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconCoins"><Path d="M22 14C22 17.866 18.866 21 15 21C11.134 21 8 17.866 8 14C8 10.134 11.134 7 15 7C18.866 7 22 10.134 22 14Z" fill="currentColor"/><Path d="M14.748 6.0039C10.4463 6.13699 7 9.66603 7 14C7 15.0014 7.18398 15.9598 7.51999 16.8432C4.3648 16.1641 2 13.3582 2 10C2 6.13401 5.13401 3 9 3C11.3804 3 13.4834 4.18822 14.748 6.0039Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCoins;
